import { render, staticRenderFns } from "./ManterListaPresencaView.vue?vue&type=template&id=127606ed"
import script from "./ManterListaPresencaView.vue?vue&type=script&lang=js"
export * from "./ManterListaPresencaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports